export default __webpack_public_path__ + "static/media/IconTemperature.1491769f.svg";